/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import type { CalendarEvent, Participant } from '@repo/common';
import type { Schema$Event, Schema$EventAttendee } from '@repo/common/types/GoogleCalendar';

export function convertEventFormat(
  input: Schema$Event,
  providerId: string,
  calendarId: string
): CalendarEvent {
  // Map attendees from Schema$Event to the custom Participant interface
  const mapAttendees = (attendees: Schema$EventAttendee[] | undefined): Participant[] | null => {
    if (!attendees) return null;
    return attendees.map((attendee) => ({
      name: attendee.displayName || undefined,
      email: attendee.email || undefined
    }));
  };

  // Extract relevant fields from Schema$Event
  return {
    providerId,
    calendarId,
    title: input.summary || 'Unnamed event',
    description: input.description || '',
    uid: input.id || null,
    location: input.location || null,
    notes: input.description || null,
    url: input.htmlLink || null,
    attendees: mapAttendees(input.attendees),
    start: input.start?.dateTime || input.start?.date || null, // Prefer dateTime over date
    end: input.end?.dateTime || input.end?.date || null, // Prefer dateTime over date
    conferenceData: input.conferenceData || null
  };
}
